module.exports = __webpack_public_path__ + "img/dark.1b848eb4.jpg";